module.exports = __webpack_public_path__ + "static/avatar-1e050ed2e14448f9594f59eac25be753.jpg";